module.exports = __webpack_public_path__ + "themify.e23a7dcaefbde4e74e26.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/themify.ttf
// module id = ../../../../../src/assets/fonts/themify.ttf
// module chunks = styles